// @core/api/endpoints/task/delete_container_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete container config
 * Deletes task configuration for a container. Tasks fall back to TaskTypeDefinition defaults.
 */
export async function DeleteContainerConfig(
  config_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/container-configs/:config_id`;
  requestPath = requestPath.replace(':config_id', encodeURIComponent(config_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
